export const queryConfig = {
	refetchOnWindowFocus: false,
	retry: 1,
	cacheTime: 1000 * 10 * 60,
}
